import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { CheckIcon, CloseIcon } from "./Icons";

interface StatusToastProps {
  message: string | undefined;
  onDismiss: () => void;
}

export function StatusToast({ message, onDismiss }: StatusToastProps) {
  const { t } = useTranslation();

  useEffect(() => {
    if (!message) return;
    const timeout = window.setTimeout(onDismiss, 4_000);
    return () => window.clearTimeout(timeout);
  }, [message, onDismiss]);

  if (!message) return null;
  return (
    <div role="status" className="fixed bottom-24 right-4 z-[70] flex max-w-[calc(100vw-2rem)] items-center gap-3 rounded-xl border border-line-strong bg-surface-raised px-4 py-3 text-sm font-semibold text-ink shadow-[0_1rem_3rem_rgb(0_0_0/0.24)] lg:bottom-6 lg:right-6">
      <span aria-hidden="true" className="grid size-7 shrink-0 place-items-center rounded-full bg-exercise-soft text-exercise-strong"><CheckIcon className="size-4" /></span>
      <span>{message}</span>
      <button type="button" onClick={onDismiss} aria-label={t("common.close")} className="pressable -mr-1 grid size-9 shrink-0 place-items-center rounded-lg text-muted hover:bg-surface hover:text-ink focus-ring"><CloseIcon className="size-4" /></button>
    </div>
  );
}
